// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"642":"70b35656","879":"e92178bc"}[chunkId] + ".chunk.css";
};